import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function Ajuda() {
  return (
    <div className="flex flex-col min-h-screen font-questrial">
      {/* Navbar */}
      <header className="bg-blue-500 sticky top-0 z-10">
        <NavBar />
      </header>

      {/* Main Content */}
      <main className="flex-grow bg-gray-100">
        {/* Header Section */}
        <section className="bg-blue-500 text-white py-6 md:py-8 shadow-md">
          <h1 className="text-md md:text-lg lg:text-lg font-bold text-center">
            Ajuda e Suporte - Eyazs Imperium
          </h1>
        </section>

        {/* FAQ Section */}
        <section className="max-w-6xl mx-auto p-4 md:p-6 bg-white shadow-lg rounded-lg mt-6">
          <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
            Dúvidas Frequentes (FAQ)
          </h2>
          <ul className="list-disc list-inside text-gray-700 text-sm md:text-lg mb-4 leading-relaxed">
            <li>
              <strong>
                Como posso contratar o serviço de internet da Eyazs Imperium?
              </strong>
              <p className="mt-2">
                Você pode contratar nossos serviços de forma simples e rápida:
              </p>
              <ol className="list-decimal list-inside space-y-2 mt-2 pl-6">
                <li>
                  <strong>Pelo Telefone ou WhatsApp:</strong> Ligue para
                  <a
                    href="tel:+258851904232"
                    className="text-blue-500 hover:underline"
                  >
                    {" "}
                    (+258) 851904232
                  </a>
                  ou envie uma mensagem pelo WhatsApp em
                  <a
                    href="https://wa.me/+258851904232"
                    className="text-blue-500 hover:underline"
                  >
                    {" "}
                    (+258) 851904232
                  </a>
                  .
                </li>
                {/*
  <li>
    <strong>Visite Nossas Sucursais:</strong>
    <ul className="list-disc list-inside mt-2 pl-6">
      <li>
        <strong>Maputo:</strong> Rua 33, 8º Bairro Macurungo,
        Cidade da Maputo, Sofala, Mozambique
      </li>
      <li>
        <strong>Beira:</strong> Rua 33, 8º Bairro Macurungo,
        Cidade da Beira, Sofala, Mozambique
      </li>
      <li>
        <strong>Tete:</strong> Rua 33, 8º Bairro Macurungo,
        Cidade da Tete, Sofala, Mozambique
      </li>
      <li>
        <strong>Nampula:</strong> Rua 33, 8º Bairro Macurungo,
        Cidade da Nampula, Sofala, Mozambique
      </li>
    </ul>
  </li>
*/}
                <li>
                  <strong>Email:</strong> Envie para 
                  <a
                    href="mailto:contratacao@eyazsimperium.co.mz"
                    className="text-blue-500 ml-1 hover:underline"
                  >
                    geral@eyazs.com
                  </a>
                  .
                </li>
              </ol>
            </li>
            <li>
              <strong>Quais planos de internet estão disponíveis?</strong>
              <p className="mt-2">
                Consulte a página de{" "}
                <a href="/planos" className="text-blue-500 hover:underline">
                  Planos e Preços
                </a>
                .
              </p>
            </li>
            <li>
              <strong>Como posso pagar minha fatura mensal?</strong>
              <p className="mt-2">
                Acesse aos{" "}
                <a
                  className="text-blue-500 hover:underline"
                  href="/planos"
                >
                  Planos de internet
                </a>{" "}
                ou dirija-se a uma das sucursais.
              </p>
            </li>
            <li>
              <strong>O que fazer se minha internet parar de funcionar?</strong>
              <p className="mt-2">
                Você pode contactar nossos Técnicos através dos nossos canais:
              </p>
              <ul className="list-disc list-inside mt-2 pl-6">
                <li>
                  <strong>Pelo Telefone ou WhatsApp:</strong> Ligue para
                  <a
                    href="tel:+258851904232"
                    className="text-blue-500 hover:underline"
                  >
                    {" "}
                    (+258) 851904232
                  </a>{" "}
                  ou envie uma mensagem pelo WhatsApp em
                  <a
                    href="https://wa.me/+258851904232"
                    className="text-blue-500 hover:underline"
                  >
                    {" "}
                    (+258) 851904232
                  </a>
                  .
                </li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Tutorials Section */}
        <section className="max-w-6xl mx-auto p-4 md:p-6 bg-white shadow-lg rounded-lg mt-6">
          <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
            Tutoriais Rápidos
          </h2>
          <p className="text-sm md:text-base text-gray-700">
            Aprenda como configurar seu roteador, verificar a velocidade de
            internet e muito mais.
          </p>
        </section>

        {/* Contact Section */}
        <section className="max-w-6xl mx-auto p-4 md:p-6 bg-white shadow-lg rounded-lg mt-6">
          <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
            Contatos de Suporte
          </h2>
          <ul className="space-y-2 text-sm md:text-base text-gray-700">
            <li>
              <strong>Telefone Comercial:</strong> (+258) 86-801-2012
            </li>
            <li>
              <strong>Telefone Técnico:</strong> (+258) 86-901-2012
            </li>
            <li>
              <strong>Telefone Administrativo:</strong> (+258) 86-301-2012
            </li>
            <li>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:comercial@eyazs.com"
                className="text-blue-500 hover:underline"
              >
                comercial@eyazs.com
              </a>
            </li>
            <li>
              <strong>WhatsApp:</strong>{" "}
              <a
                className="text-blue-500 hover:underline"
                href="https://wa.me/+258851904232"
              >
                (+258) 851-904-232
              </a>
            </li>
            <li>
              <strong>Horário de Atendimento:</strong> Segunda a Sexta, das 8h
              às 17h. Sábado, das 8h às 12h.
            </li>
          </ul>
        </section>
      </main>

      {/* Footer */}
      <div>
        <Footer />
      </div>
    </div>
  );
}
